import {
  EViewerMode,
  ProjectDetailContext,
} from "../Interfaces/ProjectDetailInterfaces";
import { Q3DTabPanel } from "../../Parts/Q3DTabPanel";
import { useContext, useEffect, useState } from "react";
import { Box, useTheme } from "@mui/material";
import { Vector3 } from "three";
import React from "react";

type Props = {
  width?: string;
};

export const DefaultTabPanel = (props: Props) => {
  const [cursorCoord, setCursorCoord] = useState<string>(null);
  const { viewer } = useContext(ProjectDetailContext);

  const theme = useTheme();

  const startCoordTracking = () => {
    viewer.startCoordTracking((res: Vector3) => {
      if (res) {
        setCursorCoord(
          `X: ${res.y.toFixed(3)} Y: ${res.x.toFixed(3)} Z: ${res.z.toFixed(3)}`
        );
      } else {
        setCursorCoord(null);
      }
    });
  };

  useEffect(() => {
    document.addEventListener("pointloaded", startCoordTracking);

    return () => {
      document.removeEventListener("pointloaded", startCoordTracking);
      viewer.endCoordTracking();
    };
  }, []);

  return (
    <Q3DTabPanel
      value={EViewerMode.DEFAULT}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: "var(--space-space--4, 4px)",
        width: props.width,
        paddingLeft: "4px",
      }}
    >
      <Box sx={{ color: theme.palette.base.contrast }}>
        {cursorCoord ? cursorCoord : `X: --.---  Y: --.---   Z: --.---`}
      </Box>
    </Q3DTabPanel>
  );
};
